// react
import { useContext } from 'react';

// context
import { ContextContracts } from '../../Project.context';

// mui
import { Container, Grid } from '@mui/material';

// tables
import { TableContracts } from '../../../../tables/cards/TableContracts/TableContracts';

export const Details = () => {
	const { contracts, isLoadingContracts, paginationContracts, refetchContracts } =
		useContext(ContextContracts);

	return (
		<Container maxWidth={false}>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<TableContracts
						contracts={contracts}
						frame="SUPPLIERS"
						hasExport={true}
						isLoading={isLoadingContracts}
						pagination={paginationContracts}
						refetchContracts={refetchContracts}
					/>
				</Grid>
			</Grid>
		</Container>
	);
};
